import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IForgotPasswordModalSettings } from '@shared/core/interfaces/forgot-password.interface';
import { RecaptchaComponent } from 'ng-recaptcha';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ForgotPasswordService } from '../../services/forgot-password/forgot-password.service';

@Component({
  selector: 'pw-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordModalComponent implements OnInit {

  private _unsubscribe$: Subject<void> = new Subject<void>();
  @ViewChild(RecaptchaComponent, { static: true }) public recaptcha: RecaptchaComponent;

  public forgotPasswordForm: UntypedFormGroup = new UntypedFormGroup({
    username: new UntypedFormControl(''),
    re_captcha_response: new UntypedFormControl('', Validators.required),
  });
  readyToSend = false;

  constructor(
    private _toastr: ToastrService,
    public _forgotPasswordService: ForgotPasswordService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: IForgotPasswordModalSettings
  ) {}

  public ngOnInit(): void {
    console.log(this.data);
    if (!!this.data) this.forgotPasswordForm.patchValue({ username: this.data.username });
  }

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
    this.readyToSend = true;
  }

  doPasswordResetRequest() {
    const { username } = this.forgotPasswordForm.value;
    console.log(`doing password reset request for user ${username}`);

    this._forgotPasswordService
      .sendPasswordResetRequest(this.forgotPasswordForm.value)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(
        (res) => {
          console.log(res), this._toastr.success(`Email will be sent by email to ${username}`, 'Success');
        },
        (err) => this._toastr.error(err, 'Error')
      )
      .add(() => this.recaptcha.reset());
  }
}
